'use strict';

angular.module('app.footer', ['sharecrf-version'])
    .controller('FooterController', ['ShareCrfUrl', 'ShareCrfLanguageService', 'ShareCrfVersion', function(ShareCrfUrl, ShareCrfLanguageService, ShareCrfVersion) {
        var vm = this;

        var urlWeb = ShareCrfUrl.getWww();
        var lang = ShareCrfLanguageService.getLanguage();

        vm.versionData = ShareCrfVersion.get();

        var footerLinks = {
            front: {
                es: 'es',
                en: '',
            },
            terms: {
                es: 'es/terminos-uso-servicio',
                en: 'terms-use-service',
            },
            privacy: {
                es: 'es/politica-privacidad',
                en: 'privacy-policy',
            },
            conditions: {
                es: 'es/terminos-condiciones-servicio',
                en: 'service-terms-conditions',
            },
            cookies: {
                es: 'es/politica-cookies',
                en: 'cookies-policy',
            },
        };

        vm.getLink = function(key) {
            return footerLinks[key] ? urlWeb + footerLinks[key][lang.code || 'es'] : '#';
        };

        vm.currentYear = (new Date()).getFullYear();
    }]);
